// Title-splitting helpers shared across templates. Centralizing these
// keeps "last word in script" / "first half in colour" / "word per line"
// treatments consistent regardless of which template renders.

export function splitByWords(title: string): string[] {
  return title.trim().split(/\s+/).filter(Boolean);
}

export function splitLastWord(title: string): { lead: string; tail: string } {
  const words = splitByWords(title);
  if (words.length <= 1) return { lead: '', tail: words[0] ?? '' };
  return {
    lead: words.slice(0, -1).join(' '),
    tail: words[words.length - 1],
  };
}

export function splitAtMidpoint(title: string): {
  first: string;
  second: string;
} {
  const words = splitByWords(title);
  if (words.length <= 1) return { first: words[0] ?? '', second: '' };
  const mid = Math.ceil(words.length / 2);
  return {
    first: words.slice(0, mid).join(' '),
    second: words.slice(mid).join(' '),
  };
}
